import type { ColDef } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'

export const accrued_interests = {
  field: 'accrued_interests',
  headerName: 'Accrued Interests',
  cellDataType: 'number',
  cellEditor: 'agNumberCellEditor',
  valueParser: ({ newValue, oldValue }) => {
    if (newValue == null || typeof newValue === 'boolean' || String(newValue).trim() === '') return oldValue
    const value = Number(newValue)
    return Number.isFinite(value) ? value : oldValue
  },
  valueFormatter: numberFormatter({ delimiter: true }),
  cellClass: 'text-right',
  width: 160,
} satisfies ColDef

export const trade_date = {
  field: 'trade_date',
  headerName: 'Trade Date',
  rowGroup: true,
  hide: true,
  width: 125,
}

export const strategy_name = {
  field: 'strategy_name',
  headerName: 'Strategy',
  width: 115,
}

export const active = {
  field: 'active',
  width: 100,
}

export const unique_identifier = {
  field: 'unique_identifier',
  headerName: 'Instrument',
  cellClass: 'text-center',
  width: 275,
}

export const instrument_type = {
  field: 'instrument_type',
  headerName: 'Inst Type',
  cellClass: 'text-center',
  width: 125,
}

export const price = {
  field: 'price',
  valueFormatter: numberFormatter({
    minimumFractionDigits: 6,
    delimiter: true,
  }),
  cellClass: 'text-right',
  width: 125,
}

export const quantity = {
  field: 'quantity',
  valueFormatter: numberFormatter({ delimiter: true }),
  cellClass: 'text-right',
  width: 150,
}

export const notional = {
  field: 'notional',
  valueFormatter: numberFormatter({ delimiter: true }),
  cellClass: 'text-right',
  width: 150,
}

export const trade_currency = {
  field: 'trade_currency',
  headerName: 'Trade Ccy',
  cellClass: 'text-center',
  width: 115,
}

export const trade_datetime_utc = {
  field: 'trade_datetime_utc',
  headerName: 'Trade DT UTC',
  cellClass: 'text-center',
}

export const settlement_date = {
  field: 'settlement_date',
  headerName: 'Sett Date',
  cellClass: 'text-center',
  width: 125,
}

export const trade_type = {
  field: 'trade_type',
  headerName: 'Trade Type',
  cellClass: 'text-center',
  width: 125,
}

export const comment = {
  field: 'comment',
  cellClass: 'text-left',
  width: 250,
}
